
export default {
	methods: {
	  allGoals(team, own = false) {
		if (this.currentSubTab === 'all') {
			let goals = this.getTeamMatches(team).reduce((sum, match) => {
				if (match.localteam_id === team.team_id) {
					return sum + parseInt(match.localteam_goals);
				} else {
					return sum + parseInt(match.visitorteam_goals);
				}
			}, 0);
			if (own === false) {
				goals += ':' + this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id) {
						return sum + parseInt(match.localteam_goals);
					} else {
						return sum + parseInt(match.visitorteam_goals);
					}
				}, 0);
			}
			return goals;
		} else if (this.currentSubTab === 'home') {
			let goals = this.getTeamMatches(team).reduce((sum, match) => {
				if (match.localteam_id === team.team_id) {
					return sum + parseInt(match.localteam_goals);
				} else {
					return sum;
				}
			}, 0);
			if (own === false) {
				goals += ':' + this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id) {
						return sum + parseInt(match.visitorteam_goals);
					} else {
						return sum;
					}
				}, 0);
			}
			return goals;
		} else if (this.currentSubTab === 'away') {
			let goals = this.getTeamMatches(team).reduce((sum, match) => {
				if (match.visitorteam_id === team.team_id)
					return sum + parseInt(match.visitorteam_goals);
				else
					return sum;
			}, 0);
			if (own === false) {
				goals += ':' + this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id) {
						return sum + parseInt(match.localteam_goals);
					} else {
						return sum;
					}
				}, 0);
			}
			return goals;
		}
	},
	  getTeamMatches(team, matchDetail = null, all = false) {
		let matches = team.matches.slice().filter(match => {
			return match.status === 'FT';
		}).sort((a, b) => new Date(a.date) - new Date(b.date));
      if (this.displayedTable === 'rounds') {
        matches = this.getMatchesBeforeXRound(matches);
      } else if (this.displayedTable === 'form' || this.displayedTable === 'full') {
        matches = this.getLastXMatches(matches);
      } else if (matchDetail) {
        if (matchDetail === 'all') {
          return matches;
        } else if (matchDetail === 'home') {
          return matches.filter((match) => {
            return match.localteam_id === team.team_id
          });
        } else if (matchDetail === 'away') {
          return matches.filter((match) => {
            return match.visitorteam_id === team.team_id
          });
        }
      } else {
        if (this.currentSubTab === 'all' || all) {
          return matches;
        } else if (this.currentSubTab === 'home') {
          return matches.filter((match) => {
            return match.localteam_id === team.team_id
          });
        } else if (this.currentSubTab === 'away') {
          return matches.filter((match) => {
            return match.visitorteam_id === team.team_id
          });
        }
      }
			return matches;
		},
		allMatches(team) {
			if (this.currentSubTab === 'all')
				return this.getTeamMatches(team).length;
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id)
						return sum + 1;
					else
						return sum;
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id)
						return sum + 1;
					else
						return sum;
				}, 0);
		},
		allMatchesWithoutCorners(team) {
			if (this.currentSubTab === 'all')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if ((parseInt(match.visitorteam_stats.corners) + parseInt(match.localteam_stats.corners)) === 0)
						return sum + 1;
					else
						return sum;
				}, 0);
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id &&
						(parseInt(match.visitorteam_stats.corners) + parseInt(match.localteam_stats.corners)) === 0)
						return sum + 1;
					else
						return sum;
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id &&
						(parseInt(match.visitorteam_stats.corners) + parseInt(match.localteam_stats.corners)) === 0)
						return sum + 1;
					else
						return sum;
				}, 0);
		},
		allMatchesWithCorners(team) {
			return this.getTeamMatches(team).length;
		},
		getPoints(team, all = false) {
			return this.allWins(team, all)*3 + this.allDraws(team, all);
		},
		allWins(team, all = false) {
			if (this.currentSubTab === 'all' || all)
				return this.getTeamMatches(team, all).reduce((sum, match) => {
					if ((match.localteam_id === team.team_id && parseInt(match.localteam_goals) > parseInt(match.visitorteam_goals))
						|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_goals) < parseInt(match.visitorteam_goals))) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id && parseInt(match.localteam_goals) > parseInt(match.visitorteam_goals)) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id && parseInt(match.localteam_goals) < parseInt(match.visitorteam_goals)) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
		},
		allDraws(team, all = false) {
			if (this.currentSubTab === 'all' || all)
				return this.getTeamMatches(team, all).reduce((sum, match) => {
					if (parseInt(match.localteam_goals) === parseInt(match.visitorteam_goals)) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id && parseInt(match.localteam_goals) === parseInt(match.visitorteam_goals)) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id && parseInt(match.localteam_goals) === parseInt(match.visitorteam_goals)) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
		},
		allLosses(team) {
			if (this.currentSubTab === 'all')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if ((match.localteam_id === team.team_id && parseInt(match.localteam_goals) < parseInt(match.visitorteam_goals))
						|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_goals) > parseInt(match.visitorteam_goals))) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id && parseInt(match.localteam_goals) < parseInt(match.visitorteam_goals)) {
						return sum + 1;
					}
					else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id && parseInt(match.localteam_goals) > parseInt(match.visitorteam_goals))
						return sum + 1;
					else
						return sum;
				}, 0);
		},
		sortTable(column, event, disableAsc = false, earlyReturn = false) {
			if (earlyReturn) {
				return;
			}
			let eventTarget;
			if (event.target.tagName === 'DIV') {
				eventTarget = event.target;
			} else {
				eventTarget = event.target.parentElement.parentElement;
			}
			if (column !== this.sortColumn) {
				this.sortAscending = 0;
				this.sortColumn = column;
			} else if (!disableAsc) {
				this.sortAscending = !this.sortAscending;
			}
			this.previousSortColumn = eventTarget;
		},
		checkStatus(status) {
			return ['FT', 'AET', 'PEN'].includes(status);
		},
		getSpotDetails(detail, position, leagueId){
			if (this.currentSubTab !== 'all' || this.currentRoundTab ) {
				return '';
			}
			if (detail === 'Ligue_1_(Promotion_-_Play_Offs:_)') {
				return 'foot-tab-row-marked-red-variant'; // jednorazowa dziwna pozycja
			}
			if (leagueId === '40') {
				if (position === 2){
					return 'foot-tab-row-marked-blue';
				}
				if (position === 6) {
					return '';
				}
			}
			if (this.variant === 'group') {
				if (this.details[0].league_id === '32') {
					if (position === 0) {
						return 'foot-tab-row-marked-blue'
					}
					if (position === 1) {
						return 'foot-tab-row-marked-blue-variant'
					}
				}
				if (this.details[0].league_id === '34') {
					if (position <= 5) {
						return 'foot-tab-row-marked-blue'
					}
					if (position === 6) {
						return 'foot-tab-row-marked-blue-variant'
					}
				}
				if (this.leagueTable.length > 4 && this.details[0].league_id === '4') {
					if (position <= 3) {
						return 'foot-tab-row-marked-blue'
					}
				}
				if (position < 2) {
					return 'foot-tab-row-marked-blue';
				}
				if (position === 2) {
					return this.details[0].league_id === '4' ? 'foot-tab-row-marked-green' : '';
				}
				return '';
			}
			let qualifierCheckConditions = ['qualifiers', 'qualification', '(relegation)', 'play-off', '(relegation' ,'1/16'];
			let markedBlue = ['champions_league', 'final_series', 'championship'];
			let blueExceptions = ['relegation_-_championship'];
			let markedRed = ['relegation'];
			let markedPurple = ['conference'];
			let markedGreen = ['europa_league', 'promotion'];

			let qualifier = qualifierCheckConditions.some(condition => {
				return detail?.toLowerCase().includes(condition);
			}) ? '-variant' : '';
			if (markedBlue.some(condition => {return detail.toLowerCase().includes(condition)}) && !blueExceptions.some(exc => {return detail.toLowerCase().includes(exc)})) {
				return 'foot-tab-row-marked-blue' + qualifier;
			}
			if (markedPurple.some(condition => {return detail.toLowerCase().includes(condition)})) {
				qualifier = detail.toLowerCase().includes('play-offs') ?  '-variant' : '';
				return 'foot-tab-row-marked-purple' + qualifier;
			}
			if (markedRed.some(condition => {return detail.toLowerCase().includes(condition)})) {
				return 'foot-tab-row-marked-red' + qualifier;
			}
			if (markedGreen.some(condition => {return detail.toLowerCase().includes(condition)})) {
				return 'foot-tab-row-marked-green' + qualifier;
			}
		},
    getMatchesBeforeXRound(matches) {
      return matches.filter(match => {
        return Number(match.round.split(" ").slice(-1)) <= this.currentRoundTab && match.status === 'FT';
      });
    },
    getLastXMatches(matches) {
      return matches.slice(-this.currentRoundTab);
    },
	cupRoundName(name, league_id = 0, roundMatches = 0, withGroupString = true) {
			if (!['Cup', 'European Cup', 'National Cup'].includes(this.leagueType)) {
				return '';
			}

		name = name.replace(/ id_.*/, '');
		let roundName = name;
		name = name.toLowerCase();

		if (name.includes('preliminary')) {
			return 'Runda wstępna';
		}
			if (roundMatches !== 0 && (+roundMatches & (+roundMatches - 1)) === 0) {
				switch (+roundMatches) {
					case 1:
						roundName = 'Finał';
						break;
					case 2:
						roundName = 'Półfinał';
						break;
					case 4:
						roundName = 'Ćwierćfinał';
						break;
					case 8:
						roundName = '1/8 finału';
						break;
					case 16:
						roundName = '1/16 finału';
						break;
					case 32:
						roundName = '1/32 finału';
						break;
					case 64:
						roundName = '1/64 finału';
						break;
					case 128:
						roundName = '1/128 finału';
						break;
				}
				if (name.includes('replays')) {
					roundName += ' - rewanże';
				}
				return roundName;
			}

			const regex = /League (\w) - (\d+)/;
			if (regex.test(roundName)) {
				roundName = roundName.replace(regex, (match, letter, number) => {
					return `Liga ${letter} - Kolejka ${number}`;
				});
			}
			if (name.includes('round of') && +roundMatches === 0) {
				const noOfMatches = +name.split(' ').reverse()[0] / 2;
				roundName = `1/${noOfMatches} finału`;
			}
			if (name.includes('play-offs')) {
				roundName = [2,3,848].includes(league_id) ? 'Kwalifikacje' : 'Play-offy';
			}
			if (name.includes('knockout round play-offs')) {
				roundName = '1/16 finału';
			}
			if (name.includes('group stage')) {
				let match = name.match(/\b\d+\b/);
				if (withGroupString) {
					roundName = 'Faza grupowa - Kolejka ';
				} else {
					roundName = 'Kolejka ';
				}
				roundName += match ? match[0] : null;
			}
			if (name.includes('league stage')) {
				let match = name.match(/\b\d+\b/);
				roundName = 'Faza Ligowa - Kolejka ';
				roundName += match ? match[0] : null;
			}
			if (name.includes('st ro')) {
				roundName = `Runda ${name.substring(0, name.indexOf('st'))}`;
			}
			if (name.includes('th ro')) {
				roundName = `Runda ${name.substring(0, name.indexOf('th'))}`;
			}
			if (name.includes('nd ro')) {
				roundName = `Runda 2`;
			}
			if (name.includes('rd ro')) {
				roundName = `Runda 3`;
			}
			if (name.includes('quarter')) {
				roundName = 'Ćwierćfinał';
			}
			if (name.includes('semi')) {
				roundName = 'Półfinał';
			}
			if (name.trim() === 'final') {
				roundName = 'Finał';
			}
			if (name.includes('qualifying round')) {
				const roundNumber = parseInt(name.match(/\d+/)[0]);
				roundName = `Runda ${roundNumber} - kwalifikacje`;
			}
			if (name.includes('round qualifying')) {
				roundName += ' - kwalifikacje';
			}
			if (name.includes('replays')) {
				roundName += ' - rewanże';
			}

			return roundName;
		},
    getFormFromFilteredMatches(team) {
      return this.getTeamMatches(team).map(match => {
        if ((Number(match.localteam_id) === Number(team.team_id) && parseInt(match.localteam_goals) > parseInt(match.visitorteam_goals))
          || (Number(match.visitorteam_id) === Number(team.team_id) && parseInt(match.localteam_goals) < parseInt(match.visitorteam_goals))) {
          return {
		    text: 'W',
		    link: '/wyniki-pilka-nozna/porownanie-druzyn/' + match.localteam_query + '/' + match.visitorteam_query + '/'
		  };
        } else if ((Number(match.localteam_id) === Number(team.team_id) && parseInt(match.localteam_goals) < parseInt(match.visitorteam_goals))
          || (Number(match.visitorteam_id) === Number(team.team_id) && parseInt(match.localteam_goals) > parseInt(match.visitorteam_goals))) {
			return {
			 text: 'P',
			 link: '/wyniki-pilka-nozna/porownanie-druzyn/' + match.localteam_query + '/' + match.visitorteam_query + '/'
			};
        }
        else {
		  return {
		    text: 'R',
		    link: '/wyniki-pilka-nozna/porownanie-druzyn/' + match.localteam_query + '/' + match.visitorteam_query + '/'
		  };
        }
      }).slice(-5)
    },

		filterTeamsByLeague(teams) {
			if (Object.keys(this.selectedLeagueOption).length === 0) {
				return teams;
			}
			if (teams.length === 0) return [];
			if (this.selectedLeagueOption.league_query_name === 'all-leagues') {
				return teams;
			}
			if (this.selectedLeagueOption.league_query_name === 'top-leagues') {
				const leagueCountries = this.selectedLeagueOption.leagues.map(league => league.country_query_name);
				const leagueNames = this.selectedLeagueOption.leagues.map(league => league.league_query_name);
				teams = teams.filter((team) => team !== undefined && leagueCountries.includes(team.country_query_name)
					&& leagueNames.includes(team.league_query_name))
				return teams;
			}
			teams = teams.filter(team => {
				return team?.league_query_name === this.selectedLeagueOption.league_query_name
					&& ((team?.country_query_name === this.selectedLeagueOption.country_query_name && this.selectedLeagueOption.league_id != 40) || this.selectedLeagueOption.league_id == 40);
			});
			return teams;
		},
		overData(overValue = 2.5) {
			let output = this.teams.map((team) => {
				let overs;
				if (this.timeFrame && this.timeFrame === '10') {
					overs = team.matches.slice(0, 10).filter((match) => (+match.goals_scored + +match.goals_lost) > overValue).length;
				} else {
					overs = team.matches.filter((match) => (+match.goals_scored + +match.goals_lost) > overValue).length;
				}
				const noOfMatches = this.timeFrame && this.timeFrame === '10' ? 10 : team.matches.length;
				return {
					name: team.name,
					shortname: team.shortname,
					league_query_name: team.league_query_name,
					country_query_name: team.country_query_name,
					team_query_name: team.team_query_name,
					id: team.id,
					logo: team.logo,
					overs: overs,
					data: [overs + '/' + noOfMatches, Math.round((overs/noOfMatches)*100)],
					next_match: team.next_match
				};
			}).sort((a, b) => {
				let result = b.data[1] - a.data[1];
				if (result == 0) {
					result = b.overs - a.overs;
					if (result == 0) {
						result = a.name.localeCompare(b.name);
					}
				}
				return result;
			});
			if (this.selectedLeagueOption) {
				output = this.filterTeamsByLeague(output);
			}
			if (!this.isLeaguePage) {
				output = output.filter(team => team?.next_match !== '-' && team !== undefined);
			}
			return output;
		},
		underData(overValue = 2.5) {
			let output = this.teams.map((team) => {
				let unders;
				if (this.timeFrame && this.timeFrame === '10') {
					unders = team.matches.slice(0, 10).filter((match) => (+match.goals_scored + +match.goals_lost) < overValue).length;
				} else {
					unders = team.matches.filter((match) => (+match.goals_scored + +match.goals_lost) < overValue).length;
				}
				const noOfMatches = this.timeFrame && this.timeFrame === '10' ? 10 : team.matches.length;
				return {
					name: team.name,
					shortname: team.shortname,
					league_query_name: team.league_query_name,
					country_query_name: team.country_query_name,
					team_query_name: team.team_query_name,
					id: team.id,
					logo: team.logo,
					unders: unders,
					data: [unders + '/' + noOfMatches, Math.round((unders/noOfMatches)*100)],
					next_match: team.next_match
				};
			}).sort((a, b) => {
				let result = b.data[1] - a.data[1];
				if (result == 0) {
					result = b.unders - a.unders;
					if (result == 0) {
						result = a.name.localeCompare(b.name);
					}
				}
				return result;
			});
			if (this.selectedLeagueOption) {
				output = this.filterTeamsByLeague(output);
			}
			if (!this.isLeaguePage) {
				output = output.filter(team => team?.next_match !== '-' && team !== undefined);
			}
			return output;
		},
		bttsData() {
			let output = this.teams.map((team) => {
				let btts;
				if (this.timeFrame && this.timeFrame === '10') {
					btts = team.matches.slice(0, 10).filter((match) => (+match.goals_scored > 0) && (+match.goals_lost > 0)).length;
				} else {
					btts = team.matches.filter((match) => (+match.goals_scored > 0) && (+match.goals_lost > 0)).length;
				}
				const noOfMatches = this.timeFrame && this.timeFrame === '10' ? 10 : team.matches.length;
				return {
					name: team.name,
					shortname: team.shortname,
					league_query_name: team.league_query_name,
					country_query_name: team.country_query_name,
					team_query_name: team.team_query_name,
					id: team.id,
					logo: team.logo,
					btts: btts,
					data: [btts + '/' + noOfMatches, Math.round((btts/noOfMatches)*100)],
					next_match: team.next_match
				};
			}).sort((a, b) => {
				let result = b.data[1] - a.data[1];
				if (result == 0) {
					result = b.btts - a.btts;
					if (result == 0) {
						result = a.name.localeCompare(b.name);
					}
				}
				return result;
			});
			if (this.selectedLeagueOption) {
				output = this.filterTeamsByLeague(output);
			}
			if (!this.isLeaguePage) {
				output = output.filter(team => team?.next_match !== '-' && team !== undefined);
			}
			return output;
		},
		winData() {
			let output = this.teams.map((team) => {
				let wins = team.matches.filter((match) => +match.goals_scored > +match.goals_lost).length;
				return {
					name: team.name,
					shortname: team.shortname,
					league_query_name: team.league_query_name,
					country_query_name: team.country_query_name,
					team_query_name: team.team_query_name,
					id: team.id,
					logo: team.logo,
					wins: wins,
					data: [wins + '/' + team.matches.length, Math.round((wins/team.matches.length)*100)],
					next_match: team.next_match
				};
			}).sort((a, b) => {
				let result = b.data[1] - a.data[1];
				if (result == 0) {
					result = b.wins - a.wins;
					if (result == 0) {
						result = a.name.localeCompare(b.name);
					}
				}
				return result;
			});
			if (this.selectedLeagueOption) {
				output = this.filterTeamsByLeague(output);
			}
			if (!this.isLeaguePage) {
				output = output.filter(team => team?.next_match !== '-' && team !== undefined);
			}
			return output;
		},
		drawData() {
			let output = this.teams.map((team) => {
				let draws = team.matches.filter((match) => +match.goals_scored === +match.goals_lost).length;
				return {
					name: team.name,
					shortname: team.shortname,
					league_query_name: team.league_query_name,
					country_query_name: team.country_query_name,
					team_query_name: team.team_query_name,
					id: team.id,
					logo: team.logo,
					draws: draws,
					data: [draws + '/' + team.matches.length, Math.round((draws/team.matches.length)*100)],
					next_match: team.next_match
				};
			}).sort((a, b) => {
				let result = b.data[1] - a.data[1];
				if (result == 0) {
					result = b.draws - a.draws;
					if (result == 0) {
						result = a.name.localeCompare(b.name);
					}
				}
				return result;
			});
			if (this.selectedLeagueOption) {
				output = this.filterTeamsByLeague(output);
			}
			if (!this.isLeaguePage) {
				output = output.filter(team => team?.next_match !== '-' && team !== undefined);
			}
			return output;
		},
		cornersData(){
			let output = this.teamsCorners.map((team) => {
				if (this.timeFrame === '10') {
					let matches = team.team_matches.slice(0, 10);
					return {
						name: team.name,
						shortname: team.shortname,
						id: team.id,
						league_query_name: team.league_query_name,
						country_query_name: team.country_query_name,
						team_query_name: team.team_query_name,
						logo: team.logo,
						cornersTotal: matches.reduce((acc, match) => acc + (+match.corners + +match.opponent_corners), 0),
						data: [matches.length, Math.round((matches.reduce((acc, match) => acc + (+match.corners + +match.opponent_corners), 0)/matches.length)*100)/100],
						next_match: team.next_match
					};
				}
				return {
					name: team.name,
					shortname: team.shortname,
					league_query_name: team.league_query_name,
					country_query_name: team.country_query_name,
					team_query_name: team.team_query_name,
					id: team.id ?? team.team_id,
					logo: team.logo,
					matches: team.matches,
					data: [team.matches, Math.ceil(team.corners.for/team.matches*100)/100],
					next_match: team.next_match
				};
			}).sort((a, b) => {
				let result = b.data[1] - a.data[1];
				if (result == 0) {
					result = b.matches - a.matches;
					if (result == 0) {
						result = a.name.localeCompare(b.name);
					}
				}
				return result;
			});
			if (this.selectedLeagueOption) {
				output = this.filterTeamsByLeague(output);
			}
			if (!this.isLeaguePage) {
				output = output.filter(team => team?.next_match !== '-' && team !== undefined);
			}
			output = output.filter(team => team.data[1] > 0);
			return output;
		},
		getStatTooltip(shortcut, tableType) {
			if (tableType === 'cleanSheets') {
				switch (shortcut) {
					case 'Cz.k./M': return 'Czyste konto / Mecze';
				}
			}
			switch (shortcut) {
				case 'G'  : return 'Gole';
				case 'O/M': return 'Over / Mecze';
				case 'U/M': return 'Under / Mecze';
				case 'BTTS/M' : return 'Obie drużyny strzelą gola / Mecze';
				case 'W/M': return 'Wygrane / Mecze';
				case 'P/M': return 'Przegrane / Mecze';
				case 'R/M': return 'Remisy / Mecze';
				case 'Ż.k./M': return 'Żółte kartki / Mecze';
				case 'Cz.k./M': return 'Czerwone kartki / Mecze';
				case 'M': return 'Mecze';
				case 'Ł/M': return 'Łamaki / Mecze';
				case 'Cz./M': return 'Czyste konto / Mecze';
				case 'Brak Cz./M': return 'Brak czystego konta / Mecze';
				case 'K/M': return 'Karne / Mecze';
				case 'Od': return 'Data rozpoczęcia serii';
				case 'Next': return 'Następny mecz ligowy';
				case 'Seria': return 'Trwające serie w meczach ligowych';
				case 'Czyste/M': return 'Czyste konta / Mecze';
			}
			return '';
		},
		getSeasonPhaseString(name) {
			switch (name) {
				case 'Championship_Round':
					return 'Grupa Mistrzowska';
				case 'Relegation_Round':
					return 'Grupa Spadkowa';
				case 'Regular_Season':
					return 'Sezon Zasadniczy';
				case 'Conference_League_Play-off_Group':
					return 'Grupa Ligi Konferencji'
				case 'Western_Conference':
					return 'Konferencja Zachodnia'
				case 'Eastern_Conference':
					return 'Konferencja Wschodnia'
				default:
					return name;
			}
		},
		getMatchRoundString(round) {
			round = round.replace(/ id_.*/, '');
			let baseString = this.getBaseString(round);
			round = round.replace(baseString.base, '');
			round = round.replace('Friendlies', 'Mecze Towarzyskie');
			round = round.replace('League', 'Liga');
			let roundStringSplit = round.split(' ');
			if (roundStringSplit[roundStringSplit.length - 1].replace(/\D/g, '').length > 5) {
				roundStringSplit.pop();
			}
			round = roundStringSplit.join(' ');
			round = round.replace('Regular Season', '')

			return this.formatRoundString(baseString.replaced, round, roundStringSplit);
		},

		getBaseString(round) {
			let base = {
				base : '',
				replaced: ''
			};
			if (round.includes('Championship Round'))
				return {base: 'Championship Round', replaced: 'Grupa Mistrzowska '};
			if (round.includes('Conference League Play-off Group'))
				return {base: 'Conference League Play-off Group', replaced: 'Grupa Ligi Konferencji '};
			if (round.includes('Conference League Play-offs'))
				return {base: 'Conference League Play-off Group', replaced: 'Liga Konferencji Play-Offy '};
			if (round.includes('Relegation Round'))
				return {base: 'Relegation Round', replaced: 'Grupa Spadkowa '};
			if (round.includes('Championship'))
				return {base: 'Championship', replaced: 'Mistrzowstwo '};
			return base;
		},

		formatRoundString(baseString, round, roundStringSplit) {
			if (/\d/.test(roundStringSplit) && (round.includes('Group Stage') || round.includes('Round'))) {
				return this.processDigitsInRound(baseString, round);
			} else if (!/\d/.test(roundStringSplit)) {
				return this.processNonDigitRound(baseString, round);
			} else {
				let index = roundStringSplit.findIndex(el => /\d/.test(el));
				if (index !== -1) {
					return `${baseString}${roundStringSplit[index].replace(/\D/g, '')}. kolejka`;
				}
				return `${baseString}${roundStringSplit.reverse()[0] + (/\d/.test(roundStringSplit.reverse()[0]) ? '. kolejka' : '')}`;
			}
		},

		processDigitsInRound(baseString, round) {
			if (round.includes('Group Stage')) {
				round = round.replace('Group Stage', 'Faza Grupowa');
			}
			if (round.includes('3rd Place')) {
				return `${baseString}mecz o 3-ecie miejsce`;
			}
			if (round.includes('Towarzyskie')) {
				return `${baseString}${round.replace(/\d/g, "")}`;
			}
			if (round.includes('Cup')) {
				return `${baseString}${round.replace(/\b\d+\b/g, 'kolejka $&')
					.replace('Round', '')
					.replace('MLS', '')
					.replace('Cup', 'Faza Pucharowa')}`;
			}
			return `${baseString}${round.replace(/\b\d+\b/g, 'kolejka $&')}`;
		},

		processNonDigitRound(baseString, round) {
			if (round.includes("Final")) {
				baseString += '- Finał';
			}
			if (round.includes("Semi-final")) {
				baseString += '- Półfinał';
			}
			if (round.includes("Play-In")) {
				baseString += '- Runda wstępna';
			}
			if (round.includes("Towarzyskie")) {
				return `${baseString} Towarzyskie`;
			}
			return baseString;
		},
		getTitleString(groupName) {
			switch (groupName) {
				case 'Eastern Conference':
					return 'Konferencja Wschodnia';
				case 'Western Conference':
					return 'konferecja Zachodnia';
				default:
					return 'Drużyna';
			}
		},
		checkPromotionIcon(match, league) {
			return (league.league_type === 'Cup' || ((league.league_type === 'European Cup' || league.league_type === 'National Cup'))) &&
				!match.round.includes('Group') && !match.round.includes('League') && !match.round.includes('Friendlies')
				&& (match.double_match.is_double_match && match.double_match.match_no === 2 || !match.double_match.is_double_match);
		},
		isMatchRoundInPlayOffs(roundName) {
			let rounds = ['Semi-finals', 'Quarter-finals', 'Round of 16', 'Round of 32']
			return rounds.some(el => roundName.includes(el));
		}
	}
}